var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneralSettingsUnselectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_580_103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33326 10.2133C1.33326 8.45696 1.85406 6.74011 2.82981 5.2798C3.80555 3.81949 5.19242 2.68132 6.81503 2.00921C8.43764 1.3371 10.2231 1.16125 11.9457 1.50389C13.6682 1.84653 15.2505 2.69226 16.4924 3.93415C17.7343 5.17604 18.58 6.75831 18.9226 8.48086C19.2653 10.2034 19.0894 11.9889 18.4173 13.6115C17.7452 15.2341 16.607 16.621 15.1467 17.5967C13.6864 18.5725 11.9696 19.0933 10.2133 19.0933C7.85814 19.0933 5.59947 18.1577 3.93415 16.4924C2.26883 14.827 1.33326 12.5684 1.33326 10.2133Z",
    stroke: "#647084",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2131 14.1602V9.22716",
    stroke: "#647084",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2131 6.26634V6.27734",
    stroke: "#647084",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_580_103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralSettingsUnselectedIcon);
export default __webpack_public_path__ + "static/media/general_settings_unselected_icon.b0bfa9075ceedfb662b77eb91aacf8b0.svg";
export { ForwardRef as ReactComponent };